import React from 'react';

function Home() {
  return (
    <div className='text-center'>
        <h1>Eric Kohler</h1>
        <h2>Full Stack Developer</h2>
        <p className="bounce"><a href="#about"><i class="fa-solid fa-chevron-down"></i></a></p>
    </div>
  );
}

export default Home;